<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    class="text-gray-400 hover:text-gray-600"
  >
    <circle cx="3" cy="10" r="2" />
    <circle cx="9" cy="10" r="2" />
    <circle cx="15" cy="10" r="2" />
  </svg>
</template>
